module.exports = __webpack_public_path__ + "media/images/icons/filterIcon-a0fca36cb1d1f21d43c1f2e41e11223d.svg";